export enum COMPONENT_TYPES {
  BannerInfo = "BannerPlaceholder",
  Timeframes = "Timeframes",
  ContentDescription = "ContentDescription",
  FAQ = "FaqListWithTitle",
  VideoTranscript = "VideoTranscript",
}
